import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import { formatHeat, getCategoryName } from "@/utils/news";

export default function HotBoard() {
  const ranked = [...topics].sort((a, b) => b.heat - a.heat).slice(0, 6);
  const max = ranked[0]?.heat ?? 1;

  return (
    <aside className="lg:sticky lg:top-24">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="flex items-center justify-between border-b border-background-200 bg-background-100 px-4 py-3">
          <div className="flex items-center gap-2">
            <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-line text-sm" aria-hidden="true"></i>
            </span>
            <h2 className="font-heading text-base font-bold text-foreground-950">实时热议榜</h2>
          </div>
          <span className="text-[11px] text-foreground-500">每小时更新</span>
        </div>

        <ol className="divide-y divide-background-200">
          {ranked.map((topic, index) => (
            <li key={topic.id}>
              <Link
                to={`/topic/${topic.id}`}
                className="group flex gap-3 px-4 py-3 transition-colors hover:bg-background-100"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-bold ${
                    index < 3 ? "bg-primary-100 text-primary-700" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                    {topic.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-2">
                    <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                      <span
                        className="block h-full rounded-full bg-primary-400"
                        style={{ width: `${Math.max(18, (topic.heat / max) * 100)}%` }}
                      ></span>
                    </span>
                    <span className="shrink-0 text-[11px] text-foreground-500">{formatHeat(topic.heat)}</span>
                  </div>
                  <span className="mt-1.5 block text-[11px] text-foreground-500">
                    {getCategoryName(topic.category)}
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="mt-4 rounded-lg border border-accent-300 bg-accent-50 p-4">
        <h3 className="flex items-center gap-2 font-heading text-sm font-bold text-accent-900">
          <i className="ri-lightbulb-line text-base" aria-hidden="true"></i>
          怎么读一条热点
        </h3>
        <ul className="mt-3 space-y-2 text-xs leading-relaxed text-foreground-700">
          <li className="flex gap-2">
            <span className="text-accent-600">1</span>
            先看时间线，确认事情发生的先后顺序。
          </li>
          <li className="flex gap-2">
            <span className="text-accent-600">2</span>
            再看争议焦点，分清双方到底在争哪几条。
          </li>
          <li className="flex gap-2">
            <span className="text-accent-600">3</span>
            最后看核查结论，别把没定论的当成事实。
          </li>
        </ul>
      </div>
    </aside>
  );
}